import genericStore from "../generic_store";
import axios from "axios";
import { config } from "@/config/constants.js";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "users",
    object: "user",
    header: [
      { text: "Nombre", value: "name" },
      { text: "Apellido", value: "last_name" },
      { text: "Email", value: "email" },
      { text: "Fecha de creación", value: "created_at" },
      { text: "Teléfono", value: "phone_number", sortable: false },
      { text: "Estadias Realizadas", value: "rent_orders" },
      { text: "Spots", value: "spots" },
      { text: "Autos", value: "cars" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    roles: [],
    options: {
      sortBy: ["_id"],
      sortDesc: [false],
    },
    iva_conditions: ['RESP. INSCRIPTO', 'MONOTRIBUTISTA', 'CONS. FINAL', 'RELACIÓN DE DEPENDENCIA', 'JUBILADO', 'OTRO']
  },
  mutations: {
    ...genericStore.mutations,
  },
  actions: {
    ...genericStore.actions,
    getRoles({ commit }) {
      return new Promise((resolve, reject) => {
        commit("request");
        axios
          .get(config.api_url + "roles")
          .then((response) => {
            commit("success", { roles: response.data });
            resolve(response.data);
          })
          .catch((err) => {
            commit("error");
            reject(err);
          });
      });
    },
    unsubscribe({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        commit("request");
        axios
          .post(config.api_url + 'subscribe_email', data)
          .then((response) => {
            commit("success");
            resolve(response.data);
          })
          .catch((error) => {
            commit("error");
            reject(error.response.data);
          });
      });
    },
    clearList({ commit, state }, options) {
      commit("success", {
        list: [],
        total: 0,
      });
    },
  },
  getters: {
    ...genericStore.getters,
  },
};
